import styled from 'styled-components'

import { Grid } from '@material-ui/core'

import colors from '@galo-monitor/styles/colors'
import fonts from '@galo-monitor/styles/fonts'
import Button from '@galo-monitor/web-components/Button'

export const GridContainer = styled(Grid)`
  position: absolute;
  width: unset;
  right: 10px;
  bottom: 20px;
`

export const StyledButton = styled(Button)`
  padding: 0;
  min-width: 35px;
  min-height: 35px;
  font-size: ${ fonts.fontSize.XL }px;
  background-color: ${ colors.white };
  color: ${ colors.black };
  border-radius: ${ ({ id }) => id === 'increment' ? '4px 4px 0 0' : '0 0 4px 4px' };
`
